// extracted by mini-css-extract-plugin
export default {"eventContainer":"ValetudoEvents_eventContainer__Lr13I"};